// import logo from './logo.svg';
// import "./App.css";
import React from "react";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import SinglePageLayout from "./components/SinglePageLayout";
import { AuthProvider } from "./store/AuthContext";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProjectManager from "./pages/ProjectManager";
import AdminLogin from "./pages/AdminLogin";
import { isLocalEnvironment } from "./utils/environmentUtils";

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FF914D',
    },
    secondary: {
      main: '#7A9AB0',
    },
    background: {
      default: '#0D1821',
      paper: '#162333',
    },
    text: {
      primary: '#F0EEE8',
      secondary: '#7A9AB0',
    },
  },
  typography: {
    fontFamily: "'Barlow', sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    button: {
      fontWeight: 400,
      textTransform: 'none',
      letterSpacing: '0.08em',
    },
  },
  shape: {
    borderRadius: 0,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: { root: { borderRadius: 0 } },
    },
    MuiAlert: {
      styleOverrides: { root: { borderRadius: 0 } },
    },
  },
});

// ProtectedRoute component to redirect if not in local environment
function ProtectedRoute({ children }) {
  const isLocalEnv = isLocalEnvironment();
  
  if (!isLocalEnv) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Routes>
            <Route path="/" element={<SinglePageLayout />} />
            <Route path="/admin-login" element={
              <ProtectedRoute>
                <AdminLogin />
              </ProtectedRoute>
            } />
            <Route path="/project-manager" element={
              <ProtectedRoute>
                <ProjectManager />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
